module.exports = __webpack_public_path__ + "img/isle-of-man.ed4dd2bd.png";